export default __webpack_public_path__ + "static/media/mattapan_mapping_logo_2.f5c2e6bf.svg";